var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 0H4.06841C1.82149 0 0 1.82149 0 4.06841V19.9316C0 22.1785 1.82149 24 4.06841 24H19.9316C22.1785 24 24 22.1785 24 19.9316V4.06841C24 1.82149 22.1785 0 19.9316 0Z",
    fill: "#91231F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5838 7.33333L18.0538 4.35667L12.0005 4L5.94715 4.36L6.41715 7.33667H4.00049V7.67C4.00049 11.8533 7.37049 15.2633 11.5372 15.3333C11.1305 16.44 9.83049 19.3367 7.33382 19.3367V20.0033H16.6672V19.3367C14.1705 19.3367 12.8705 16.44 12.4638 15.3333C16.6305 15.2633 20.0005 11.8533 20.0005 7.67V7.33667H17.5838V7.33333ZM12.0005 4.66667L17.2805 4.98L16.6772 8.79667C16.2305 11.6233 14.5772 14.6667 12.0005 14.6667C9.42382 14.6667 7.82049 11.7167 7.32382 8.79667L6.72049 4.98L12.0005 4.66667ZM4.67382 8H6.52382L6.66715 8.90333C7.11715 11.5567 8.12049 13.25 9.25715 14.23C6.68049 13.28 4.81049 10.8667 4.67382 8ZM14.5205 19.3333H9.48382C10.7905 18.4633 11.5972 16.9367 12.0038 15.97C12.4072 16.9367 13.2138 18.4633 14.5238 19.3333H14.5205ZM14.7272 14.2367C16.1205 13 17.0172 10.9 17.3338 8.9L17.4772 8H19.3272C19.1905 10.8733 17.3138 13.2933 14.7305 14.2367H14.7272Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 0H4.06841C1.82149 0 0 1.82149 0 4.06841V19.9316C0 22.1785 1.82149 24 4.06841 24H19.9316C22.1785 24 24 22.1785 24 19.9316V4.06841C24 1.82149 22.1785 0 19.9316 0Z",
    fill: "#91231F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_177_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99951 5V15.7917C4.99951 17.5621 6.43743 19 8.20785 19H15.7912C17.5616 19 18.9995 17.5621 18.9995 15.7917V5H4.99951ZM18.4162 15.7917C18.4162 17.2383 17.2378 18.4167 15.7912 18.4167H8.20785C6.76118 18.4167 5.58285 17.2383 5.58285 15.7917V5.58333H18.4162V15.7917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0832 7.33301H7.9165V7.91634H16.0832V7.33301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7256 14.9226L9.29014 12.4872L8.87598 12.8984L11.8481 15.8705L15.1701 10.1247L14.6626 9.83301L11.7256 14.9226Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.00049 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_177_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4.99951 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.e5b3aabab5ae344a8d25bb17824a49e3.svg";
export { ForwardRef as ReactComponent };